import footer from './footer.tpl';
import '~/style/footer.less';

export default function FooterTpl() {
    const data = {
        footer_list: [
            { class: 'footer-list_1', name: '基金销售资格', url: 'https://trade.5ifund.com/qualification.html' },
            { class: 'footer-list_2', name: '监督机构', url: 'http://www.csrc.gov.cn/' },
            { class: 'footer-list_3', name: '自律组织', url: 'http://www.amac.org.cn/' },
            { class: 'footer-list_4', name: '监管银行', url: 'http://www.cmbc.com.cn/' },
            {
                class: 'footer-list_5',
                name: '安全认证',
                url: 'https://sealinfo.verisign.com/splash?form_file=fdf/splash.fdf&amp;dn=trade.5ifund.com&amp;lang=zh_cn'
            }
        ]
    };
    return {
        footer: footer(data)
    };
}